// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__pyHBO","row":"styles_row__l_L_h","even":"styles_even__5g_iZ","cell":"styles_cell__fT1z2","head":"styles_head__iUj6V"};